import { OrderButtons } from '@trashlab/sitesapp/src/organizations/redebins/template/components/shared/order-buttons';
import { PageSEO } from '@trashlab/sitesapp/src/organizations/redebins/template/components/shared/page-seo';

export const HowWeMeasureUpContent = () => {
  const comparisons = [
    {
      title: 'VS. Those Green Bags',
      benefits: [
        'No setup required',
        "Made of steel, so our walls won't collapse on you",
        'Picked up when you need',
        'Holds more for less money',
        'Can be placed on more places on your property without damaging your lawn',
        'Locally owned',
      ],
    },
    {
      title: 'VS. Junk Removal Services',
      benefits: [
        'No-contact service is COVID 19-safe',
        'No rush to decide what you want to dispose of',
        'Same-day availability',
        "Don't need to be home on delivery day",
        'Avoid the liability of having someone on your property',
        'More affordable',
      ],
    },
    {
      title: 'VS. Larger Roll-Off Dumpsters',
      benefits: [
        'Takes up less space',
        'Weigh a fraction of big roll-offs',
        'Order and pay online',
        'Driveway-friendly, both in size and weight',
        'Can be placed in an alley or yard without damaging your property',
        'Can place more than one RED-E-BIN for convenience or lower cost',
      ],
    },
    {
      title: 'VS. Dumpster Brokers',
      benefits: [
        'No hidden fees; full-disclosure pricing',
        'We own our dumpsters, and take good care of them accordingly',
        'Locally owned and operated',
        'Easy, online order management',
        'Better customer service because you deal directly with us',
        'No broker commission, so we charge less than companies like budgetdumpster.com and dumpsters.com',
      ],
    },
  ];

  return (
    <>
      <PageSEO pathname="/how-we-measure-up" />
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            {/* Intro Section */}
            <div className="text-center mb-12">
              <div className="text-6xl mb-6">📏</div>
              <h2 className="text-3xl md:text-4xl font-bold text-[#333333] mb-6 italic">
                Compare us to the Competition
              </h2>
            <div className="space-y-4 text-[#333333] max-w-4xl mx-auto">
              <p>
                At RED-E-BINS, we pride ourselves on being the go-to experts for small-size dumpster rentals. But our expertise doesn't stop there. We're also the make-it-easy experts, simplifying the dumpster rental process from start to finish. Need it fast? We've got you covered as the get-it-there-quickly experts. And when challenges arise, we're the always-here-to-solve-it experts.
              </p>
              <p>
                Unlike traditional dumpster rental companies that may offer oversized bins you don't need, we specialize in right-sized solutions that fit neatly into driveways or parking spaces. Brokers might promise convenience but often leave you waiting while they juggle multiple contractors. Not us—our streamlined service ensures we're ready when you are.
              </p>
              <p>
                What about green bags? While they may seem like a low-cost alternative, they often require additional hauling fees and limited capacity. Junk removal services? Sure, they do the heavy lifting, but the cost of labor can quickly add up, especially for projects that require multiple visits. With RED-E-BINS, you get the perfect balance of affordability, convenience, and flexibility.
              </p>
              <p>
                Our #1 goal is to make your experience as smooth and stress-free as possible. Whether you're cleaning out a garage, tackling a renovation, or managing a yard cleanup, we're here to deliver exceptional service. From easy online ordering to on-time delivery and pick-up, we make the process effortless so you can focus on what matters most—your project.
              </p>
            </div>

            {/* Order Buttons */}
            <div className="mt-8">
              <OrderButtons />
            </div>
          </div>

          {/* Comparisons Section */}
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-[#333333] mb-8 italic text-center">
              The Pros of Working with the Pros
            </h2>
            <div className="grid md:grid-cols-2 gap-8">
              {comparisons.map((comparison, index) => (
                <div key={index} className="bg-gray-50 rounded-lg p-6">
                  <h3 className="text-xl font-bold text-[#333333] mb-4 italic">
                    {comparison.title}
                  </h3>
                  <ul className="space-y-3 text-[#333333]">
                    {comparison.benefits.map((benefit, idx) => (
                      <li key={idx} className="flex items-start">
                        <span className="text-[#E31837] mr-2">✓</span>
                        <span>{benefit}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

